<template>
  <div class="wrapper">
    <div class="notice-list" v-for="(notice, idx) in notices" v-bind:key="idx">
      <div class="notice" @click="changeStatus(idx)">
        <div class="notice-info">
          <img
            style="margin-right: 6px"
            :src="
              visibleIdx === idx
                ? require('@/assets/img/ic_question_notice_black_selected.svg')
                : require('@/assets/img/ic_question_notice_normal.svg')
            "
          />
          <div class="info">
            <div class="title" :class="{ bold: visibleIdx === idx }">
              {{ notice.title }}
            </div>
            <div class="created-at">
              {{ notice.createdAt | utcToLocal("YYYY-MM-DD") }}
            </div>
          </div>
        </div>
        <img
          src="@/assets/img/ic_arrow_gray_down.svg"
          :class="{ rotate: visibleIdx !== idx }"
        />
      </div>
      <div class="content" v-if="visibleIdx === idx">
        <p v-html="notice.content"></p>
      </div>
    </div>
    <!-- end of table -->
    <div class="pagination">
      <div class="button">
        <button @click="pagination(-1)">
          <i class="fal fa-angle-left"></i>
        </button>
        <div class="total">{{ page }} / {{ totalPagination }}</div>
        <button @click="pagination(1)">
          <i class="fal fa-angle-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "공지사항",
  },
  data() {
    return {
      notices: [],
      total: "",
      page: 1,
      perPage: 5,
      totalCount: 1,
      visibleIdx: null,
    };
  },
  watch: {
    page(newVal, oldVal) {
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },
  computed: {
    totalPagination() {
      return Math.ceil(this.totalCount / this.perPage);
    },
  },
  methods: {
    changeStatus(idx) {
      idx === this.visibleIdx
        ? (this.visibleIdx = null)
        : (this.visibleIdx = idx);
    },
    getList() {
      const payload = {
        page: this.page,
        perPage: this.perPage,
      };
      this.$store
        .dispatch("notice/getNoticeList", payload)
        .then((result) => {
          this.notices = result.notices;
          this.totalCount = result.count;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    pagination(val) {
      const totalPage = this.totalPagination;
      this.visibleIdx = null;
      if (val == -1 && this.page == 1) {
        alert("첫 번째 페이지 입니다");
        return;
      }

      if (val == 1 && this.page == totalPage) {
        alert("마지막 페이지 입니다");
        return;
      }

      const newP = parseInt(this.page, 10) + val;
      this.page = newP;
    },
  },
};
</script>
<style src="./index.css" scoped></style>
<style src="@/assets/css/newPagination.css"></style>
